/**
 * Stato globale e complessivo di una macchina o di una periferica, corrisponde al campo err dei messaggi remoti mandati da Caos
 */
export enum GlobalStatusEnum {
    Unknown = -1,
    Ok = 0,
    Ko = 1,
}

export function globalStatusEnumLabel(globalStatus: GlobalStatusEnum): string {
    switch (globalStatus) {
        case GlobalStatusEnum.Ok:
            return "enum.global_status.ok";
        case GlobalStatusEnum.Ko:
            return "enum.global_status.ko";
        default:
            return "common.unknown";
    }
}